import React, { useState } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { telegramService } from '../services/api';
import styles from './Settings.module.css';

export default function Settings() {
    const user = useAuthStore((s) => s.user);
    const [linkCode, setLinkCode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const generateCode = async () => {
        setLoading(true);
        setError('');
        try {
            const res = await telegramService.getLinkCode();
            setLinkCode(res.data.code);
        } catch (err) {
            setError(err.response?.data?.message || 'حدث خطأ في توليد الرمز');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`${styles.page} text-ar`}>
            <div className={styles.pageHeader}>
                <h1>الإعدادات</h1>
            </div>

            <div className={styles.card}>
                <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>🤖</span>
                    <div>
                        <h3>ربط حساب تليغرام</h3>
                        <p className={styles.cardDesc}>أرسل التظاهرات مباشرة عبر بوت تليغرام</p>
                    </div>
                </div>

                {user?.telegram_id ? (
                    <div className={styles.linked}>
                        <div className={styles.linkedIcon}>✅</div>
                        <div>
                            <strong>حسابك مرتبط بتليغرام</strong>
                            <p className={styles.muted}>يمكنك إرسال التظاهرات مباشرة عبر البوت</p>
                        </div>
                    </div>
                ) : (
                    <div className={styles.unlinked}>
                        {!linkCode ? (
                            <button
                                className={styles.primaryBtn}
                                onClick={generateCode}
                                disabled={loading}
                            >
                                {loading ? 'جاري...' : 'ربط حساب تليغرام'}
                            </button>
                        ) : (
                            <div className={styles.codeBlock}>
                                <p className={styles.codeLabel}>رمز الربط (صالح لمدة 10 دقائق):</p>
                                <div className={styles.code}>{linkCode}</div>
                                <div className={styles.instructions}>
                                    <p>📱 تعليمات الربط:</p>
                                    <ol>
                                        <li>افتح تطبيق تليغرام</li>
                                        <li>ابحث عن البوت: <strong>@PWPTrackerBot</strong></li>
                                        <li>أرسل الأمر التالي:</li>
                                    </ol>
                                    <div className={styles.commandBox}>
                                        <code>/link {linkCode}</code>
                                        <button
                                            className={styles.copyBtn}
                                            onClick={() => {
                                                navigator.clipboard.writeText(`/link ${linkCode}`);
                                            }}
                                            title="نسخ"
                                        >
                                            📋
                                        </button>
                                    </div>
                                </div>
                                <button
                                    className={styles.secondaryBtn}
                                    onClick={generateCode}
                                    disabled={loading}
                                >
                                    توليد رمز جديد
                                </button>
                            </div>
                        )}
                        {error && <div className={styles.error}>{error}</div>}
                    </div>
                )}
            </div>

            <div className={styles.card}>
                <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>ℹ️</span>
                    <div>
                        <h3>كيفية الاستخدام</h3>
                    </div>
                </div>
                <div className={styles.helpContent}>
                    <p>بعد ربط حسابك، يمكنك إرسال التظاهرات عبر البوت بالطرق التالية:</p>
                    <ul>
                        <li><strong>نص فقط:</strong> أرسل وصف التظاهرة وسيقوم الذكاء الاصطناعي بتحليلها</li>
                        <li><strong>صورة مع وصف:</strong> أرسل صورة مع وصف وسيتم استخراج الإحداثيات من الصورة</li>
                        <li><strong>صور إضافية:</strong> بعد إرسال التظاهرة، يمكنك إرسال صور إضافية وسيتم إرفاقها تلقائياً</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
